export {
    ASK_USER_QUESTION_TOOL_NAME,
    isUserInputToolName,
    REQUEST_USER_DECISION_TOOL_NAME,
    SHOW_DYNAMIC_UI_TOOL_NAME,
} from '@apps/web/components/phoebe_chat/user_question_model';

// `update_execution_plan` was removed from every agent runtime, so no new run
// can emit it. This constant and its readers exist only to replay historical
// runs recorded before the removal — deleting them breaks the admin
// agent-traces viewer for those runs.
export const EXECUTION_PLAN_TOOL_NAME = 'update_execution_plan';
export const QUERY_TOOL_NAME = 'query';
